export function formatRegisterDateOfBirth(date) {
  if (!date) {
    return undefined
  }

  const dateObj = date instanceof Date ? date : new Date(date)

  if (Number.isNaN(dateObj.getTime())) {
    return undefined
  }

  const year = dateObj.getFullYear()
  const month = String(dateObj.getMonth() + 1).padStart(2, '0')
  const day = String(dateObj.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
